import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatEntityName'
})
export class FormatEntityNamePipe implements PipeTransform {

  transform(value: string,): string {
    if (!value) return '';

    // Replace underscores with spaces
    const noUnderscore = value.replace(/_/g, ' ');

    return noUnderscore
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

}
